var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Echarts"},[_c('div',{staticStyle:{"margin-top":"20px","width":"100%","height":"420px"},attrs:{"id":"chart"}})])
}]

export { render, staticRenderFns }